import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
const MiddleScreen = ({ getLocalAnswers }) => {
    useEffect(() => {
        getLocalAnswers('seen');
    }, []);
    return (_jsx(_Fragment, {}, void 0));
};
export default MiddleScreen;
